import { useRef, useState } from 'react'

import { FormikAutocomplete } from 'Components/UI/Atoms/CustomAutocomplete'
//import { exportClientsValidation } from "Components/Validation/Sales/Clients"
import useCustomSnackbar from 'Components/UI/Atoms/SnackBar'
import CancelConfirmButtons from 'Components/UI/Molecules/CancelConfirmButtons'
import InputsWithValidate from 'Components/UI/Molecules/InputsWithValidate'
import DialogComponent from 'Components/UI/Molecules/Modals/DialogComponent'
import { Form, Formik } from 'formik'
import { printPDF } from 'Helpers'
import { interfaces } from 'service/interfaces'

const PrintCaja = ({ open, onClose }) => {
  const [loading, setLoading] = useState(false)
  const createDismissableSnackbar = useCustomSnackbar()
  const formikRef = useRef(null)

  const handleSubmit = () => {
    formikRef.current.submitForm()
  }

  const formatDate = (date) => {
    if (!date) return null
    const d = new Date(date)
    const year = d.getFullYear()
    const month = String(d.getMonth() + 1).padStart(2, '0')
    const day = String(d.getDate()).padStart(2, '0')
    return `${year}-${month}-${day}`
  }

  const print = async (values) => {
    setLoading(true)
    const empresaId = values.origen?.id || values.origen
    const body = {
      empresa: empresaId,
      sucursal: values.sucursal,
      fecha: formatDate(values.fecha),
    }
    await interfaces.salesCaja
      .print(body)
      .then((res) => {
        printPDF(res, 500, 800).print()
        createDismissableSnackbar('Caja impresa con éxito!', {
          variant: 'success',
        })
      })
      .catch(() => {
        createDismissableSnackbar('Algo salió mal', {
          variant: 'error',
        })
      })
    onClose()
    setLoading(false)
  }

  const enteprises = [
    { id: 1, label: 'ECO' },
    { id: 2, label: 'OEM' },
    { id: 3, label: 'DOS' },
  ]

  const SUCURSAL = [
    {
      id: 1,
      label: 'ECO Río Cuarto',
    },
    {
      id: 2,
      label: 'ECO Ruta 7',
    },
    {
      id: 3,
      label: 'ECO 25 de mayo',
    },
    {
      id: 4,
      label: 'Todas',
    },
  ]

  const today = new Date()

  const fields = (setFieldValue) => [
    {
      class: 'custom',
      component: (
        <FormikAutocomplete
          label="Origen"
          name="origen"
          defaultValue={{ id: 1, label: 'ECO' }}
          options={enteprises}
          getOptionLabel={(e) => e.label}
          onChange={(_, value) => {
            setFieldValue('origen', value.id)
          }}
        />
      ),
      sm: 12,
      xs: 12,
    },
    {
      class: 'custom',
      component: (
        <FormikAutocomplete
          label="Sucursal"
          name="sucursal"
          options={SUCURSAL}
          getOptionLabel={(e) => e.label}
          onChange={(_, value) => {
            setFieldValue('sucursal', value.id)
          }}
        />
      ),
      sm: 12,
      xs: 12,
    },
    {
      class: 'text',
      label: 'Punto de venta',
      name: 'punto_venta',
      value: today,
      sm: 12,
      xs: 12,
    },
    {
      class: 'datepicker',
      label: 'Fecha',
      format: 'dd-MM-yyyy',
      name: 'fecha',
      value: today,
      sm: 12,
      xs: 12,
    },
  ]

  return (
    <DialogComponent
      open={open}
      handleclose={onClose}
      title="Imprimir cajas"
      disableBackdropClick={true}
      handleclosedisabled={loading}
      disableChildHeight
      disableEscapeKeyDown
      widthLarge="500px"
      actions={
        <CancelConfirmButtons
          onClickSubmit={handleSubmit}
          onClickCancel={onClose}
          disabledCancel={loading}
          disabledSubmit={loading}
          isLoading={loading}
        />
      }
      children={
        <Formik
          innerRef={formikRef}
          initialValues={{
            origen: { id: 1, label: 'ECO' },
            sucursal: null,
            punto_venta: null,
            fecha: today,
          }}
          onSubmit={print}
          enableReinitialize
        >
          {({ setFieldValue }) => (
            <Form>
              <InputsWithValidate
                fields={fields(setFieldValue)}
                spacing={2}
                setFieldValue={setFieldValue}
              />
            </Form>
          )}
        </Formik>
      }
    />
  )
}

export default PrintCaja
